import { Component, computed, input } from '@angular/core';
import { MatTableModule } from '@angular/material/table';

import { InfoScreenData } from '../../types/InfoScreenData';
import { bookingTypeClass } from '../../types/bookingType';
import { InfoscreenListColumn, InfoscreenListField } from '../infoscreen-module.types';
import { lockerRoomText } from '../../school-calendar/locker-room-text';

/** The icons of the old table (activity-table), plus a level and a door. */
export const ICONS = {
  clock: { viewBox: '0 0 40 40', d: 'M25.5 28.4048L27.8333 26.0714L21.6667 19.9048V12.2381H18.3333V21.2381L25.5 28.4048ZM20 37.2381C17.6944 37.2381 15.5278 36.8006 13.5 35.9256C11.4722 35.0506 9.70833 33.8631 8.20833 32.3631C6.70833 30.8631 5.52083 29.0992 4.64583 27.0714C3.77083 25.0437 3.33333 22.877 3.33333 20.5714C3.33333 18.2659 3.77083 16.0992 4.64583 14.0715C5.52083 12.0437 6.70833 10.2798 8.20833 8.77978C9.70833 7.27978 11.4722 6.09228 13.5 5.21728C15.5278 4.34229 17.6944 3.90479 20 3.90479C22.3055 3.90479 24.4722 4.34229 26.5 5.21728C28.5278 6.09228 30.2917 7.27978 31.7917 8.77978C33.2917 10.2798 34.4792 12.0437 35.3542 14.0715C36.2292 16.0992 36.6667 18.2659 36.6667 20.5714C36.6667 22.877 36.2292 25.0437 35.3542 27.0714C34.4792 29.0992 33.2917 30.8631 31.7917 32.3631C30.2917 33.8631 28.5278 35.0506 26.5 35.9256C24.4722 36.8006 22.3055 37.2381 20 37.2381ZM20 33.9048C23.6944 33.9048 26.8403 32.6062 29.4375 30.0089C32.0347 27.4117 33.3333 24.2659 33.3333 20.5714C33.3333 16.877 32.0347 13.7312 29.4375 11.134C26.8403 8.53673 23.6944 7.23812 20 7.23812C16.3055 7.23812 13.1597 8.53673 10.5625 11.134C7.96527 13.7312 6.66666 16.877 6.66666 20.5714C6.66666 24.2659 7.96527 27.4117 10.5625 30.0089C13.1597 32.6062 16.3055 33.9048 20 33.9048Z' },
  blocked: { viewBox: '0 0 31 30', d: 'M2.33333 30C1.80556 29.8889 1.3125 29.6042 0.854167 29.1458C0.395833 28.6875 0.111111 28.1944 0 27.6667L27.6667 0C28.25 0.138889 28.75 0.423611 29.1667 0.854167C29.5833 1.28472 29.875 1.77778 30.0417 2.33333L2.33333 30ZM0 19.5V14.8333L14.8333 0H19.5L0 19.5ZM0 6.66667V3.33333C0 2.41667 0.326389 1.63194 0.979167 0.979167C1.63194 0.326389 2.41667 0 3.33333 0H6.66667L0 6.66667ZM23.3333 30L30 23.3333V26.6667C30 27.5833 29.6736 28.3681 29.0208 29.0208C28.3681 29.6736 27.5833 30 26.6667 30H23.3333ZM10.5 30L30 10.5V15.1667L15.1667 30H10.5Z' },
  runner: { viewBox: '0 0 41 41', d: 'M22.0476 38.9047V28.9047L18.5476 25.5714L16.8809 32.9047L5.38092 30.5714L6.04759 27.2381L14.0476 28.9047L16.7143 15.4047L13.7143 16.5714V22.2381H10.3809V14.4047L16.9643 11.5714C17.9365 11.1547 18.6518 10.8839 19.1101 10.7589C19.5684 10.6339 19.992 10.5714 20.3809 10.5714C20.9643 10.5714 21.5059 10.7242 22.0059 11.0297C22.5059 11.3353 22.9087 11.7381 23.2143 12.2381L24.8809 14.9047C25.6031 16.0714 26.5823 17.0297 27.8184 17.7797C29.0545 18.5297 30.4643 18.9047 32.0476 18.9047V22.2381C30.2143 22.2381 28.499 21.8561 26.9018 21.0922C25.3045 20.3284 23.9643 19.3214 22.8809 18.0714L21.8809 23.0714L25.3809 26.4047V38.9047H22.0476ZM22.8809 9.73808C21.9643 9.73808 21.1795 9.41169 20.5268 8.75891C19.874 8.10613 19.5476 7.32141 19.5476 6.40474C19.5476 5.48808 19.874 4.70336 20.5268 4.05058C21.1795 3.3978 21.9643 3.07141 22.8809 3.07141C23.7976 3.07141 24.5823 3.3978 25.2351 4.05058C25.8879 4.70336 26.2143 5.48808 26.2143 6.40474C26.2143 7.32141 25.8879 8.10613 25.2351 8.75891C24.5823 9.41169 23.7976 9.73808 22.8809 9.73808Z' },
  pin: { viewBox: '0 0 41 41', d: 'M20.1905 20.5714C21.1072 20.5714 21.8919 20.2451 22.5447 19.5923C23.1975 18.9395 23.5238 18.1548 23.5238 17.2381C23.5238 16.3215 23.1975 15.5367 22.5447 14.884C21.8919 14.2312 21.1072 13.9048 20.1905 13.9048C19.2738 13.9048 18.4891 14.2312 17.8363 14.884C17.1836 15.5367 16.8572 16.3215 16.8572 17.2381C16.8572 18.1548 17.1836 18.9395 17.8363 19.5923C18.4891 20.2451 19.2738 20.5714 20.1905 20.5714ZM20.1905 32.8214C23.5794 29.7103 26.0933 26.8839 27.7322 24.3423C29.3711 21.8006 30.1905 19.5437 30.1905 17.5715C30.1905 14.5437 29.2252 12.0645 27.2947 10.134C25.3641 8.2034 22.9961 7.23812 20.1905 7.23812C17.385 7.23812 15.0169 8.2034 13.0863 10.134C11.1558 12.0645 10.1905 14.5437 10.1905 17.5715C10.1905 19.5437 11.01 21.8006 12.6488 24.3423C14.2877 26.8839 16.8016 29.7103 20.1905 32.8214ZM20.1905 37.2381C15.7183 33.4326 12.378 29.8978 10.1697 26.6339C7.96134 23.3701 6.85718 20.3492 6.85718 17.5715C6.85718 13.4048 8.19746 10.0853 10.878 7.61312C13.5586 5.1409 16.6627 3.90479 20.1905 3.90479C23.7183 3.90479 26.8225 5.1409 29.503 7.61312C32.1836 10.0853 33.5238 13.4048 33.5238 17.5715C33.5238 20.3492 32.4197 23.3701 30.2113 26.6339C28.003 29.8978 24.6627 33.4326 20.1905 37.2381Z' },
  bubble: { viewBox: '0 0 41 41', d: 'M3.90491 37.2381V7.23812C3.90491 6.32145 4.2313 5.53673 4.88407 4.88395C5.53685 4.23117 6.32157 3.90479 7.23824 3.90479H33.9049C34.8216 3.90479 35.6063 4.23117 36.2591 4.88395C36.9118 5.53673 37.2382 6.32145 37.2382 7.23812V27.2381C37.2382 28.1548 36.9118 28.9395 36.2591 29.5923C35.6063 30.2451 34.8216 30.5714 33.9049 30.5714H10.5716L3.90491 37.2381ZM9.15491 27.2381H33.9049V7.23812H7.23824V29.1131L9.15491 27.2381Z' },
  level: { viewBox: '0 0 24 24', d: 'M17 4h3v16h-3zM5 14h3v6H5zm6-5h3v11h-3z' },
  door: { viewBox: '0 0 24 24', d: 'M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z' },
};

/**
 * How wide a column may grow, relative to the others — the old table's shares (2.5 : 4 : 4.5 for
 * activity, place and info), so the standard four look as before.
 */
const WEIGHTS: Record<InfoscreenListField, string> = {
  // A floor like the old table's, so every row's columns line up whatever its time reads.
  Time: 'minmax(var(--time-col-min), auto)',
  Activity: 'minmax(0, 2.5fr)',
  Level: 'minmax(0, 1.5fr)',
  Facility: 'minmax(0, 4fr)',
  LockerRooms: 'minmax(0, 3fr)',
  Note: 'minmax(0, 4.5fr)',
};

/** A line in a cell: the large one at the top, or a small one under it. */
export interface CellLine {
  icon?: keyof typeof ICONS;
  text: string;
}

/**
 * The module's list: the old table's look (its stylesheet is shared, so the two cannot drift
 * apart) with the columns the screen is set up with — each a field shown large with its icon, and
 * small lines under it. The old screen keeps the old table with its four fixed columns.
 */
@Component({
  selector: 'app-module-table',
  imports: [MatTableModule],
  template: `
    <mat-table [dataSource]="dataSource()" class="grid-based-table mat-elevation-z8">
      @for (column of columns(); track $index; let i = $index) {
        <ng-container [matColumnDef]="'c' + i">
          <mat-cell *matCellDef="let element">
            <div class="cell-multiline-container">
              @let main = mainLine(column.field, element);
              <div class="cell-row-grid">
                <svg class="icon" width="40" height="40" [attr.viewBox]="icons[main.icon!].viewBox" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="icons[main.icon!].d" fill="currentColor" />
                </svg>
                <div class="value font-medium">{{ main.text }}</div>
              </div>
              @for (line of subLines(column, element); track $index) {
                <div class="cell-row-grid --sub">
                  <div class="icon">-</div>
                  <div class="value font-small">{{ line }}</div>
                </div>
              }
            </div>
          </mat-cell>
        </ng-container>
      }
      <mat-row
        *matRowDef="let row; columns: columnIds()"
        [class]="typeClass(row.bookingType)"
        [style.grid-template-columns]="gridTemplate()"
      ></mat-row>
    </mat-table>
  `,
  styleUrls: ['../../infoscreen-dumb/activity-table/activity-table.component.scss'],
  styles: `
    /* The time column's floor, as in the old table: 290 px, and 432 px on a 4K stage. */
    :host {
      --time-col-min: 290px;
    }
    @container infoscreen-container (min-width: 3201px) {
      :host {
        --time-col-min: 432px;
      }
    }
  `,
})
export class ModuleTableComponent {
  /** The row's class for its booking type — safe for a type the API sends as a number. */
  readonly typeClass = bookingTypeClass;
  readonly dataSource = input.required<InfoScreenData[]>();
  readonly displayDate = input.required<Date>();
  readonly columns = input.required<InfoscreenListColumn[]>();

  readonly icons = ICONS;
  readonly columnIds = computed(() => this.columns().map((_, i) => `c${i}`));
  readonly gridTemplate = computed(() => this.columns().map((c) => WEIGHTS[c.field]).join(' '));

  /** The large line: the field's icon and its value ("Info" and "Omklædning" head their lines). */
  mainLine(field: InfoscreenListField, element: InfoScreenData): CellLine {
    switch (field) {
      case 'Time':
        return { icon: 'clock', text: this.timeText(element) };
      case 'Activity':
        return isBlocked(element) ? { icon: 'blocked', text: 'Spærring' } : { icon: 'runner', text: element.activity ?? '' };
      case 'Level':
        return { icon: 'level', text: element.skillLevel ?? '' };
      case 'Facility':
        return { icon: 'pin', text: locationText(element) };
      case 'LockerRooms':
        return { icon: 'door', text: 'Omklædning' };
      case 'Note':
        return { icon: 'bubble', text: 'Info' };
    }
  }

  /**
   * The small lines: the changing rooms and the screen text under their own heading, then the
   * column's chosen details. Empty values are left out.
   */
  subLines(column: InfoscreenListColumn, element: InfoScreenData): string[] {
    const own = column.field === 'LockerRooms' || column.field === 'Note' ? this.detail(column.field, element) : [];
    return [...own, ...column.details.flatMap((field) => this.detail(field, element))].filter((line) => !!line);
  }

  private detail(field: InfoscreenListField, element: InfoScreenData): string[] {
    switch (field) {
      case 'Time':
        return [this.timeText(element)];
      case 'Activity':
        return [isBlocked(element) ? 'Spærring' : (element.activity ?? '')];
      case 'Level':
        return [element.skillLevel ?? ''];
      case 'Facility':
        return [locationText(element)];
      case 'LockerRooms':
        return (element.lockerRooms ?? []).map((room) => lockerRoomText(room));
      case 'Note':
        return [element.title ?? ''];
    }
  }

  /**
   * "08:00 - 10:00", or "Hele dagen" for a booking that runs through the whole day; a side that
   * runs past midnight is left out, as on the old screen.
   */
  private timeText(element: InfoScreenData): string {
    const day = midnight(this.displayDate());
    const start = new Date(element.start);
    const end = new Date(element.end);
    const startsBefore = midnight(start) < day;
    const endsAfter = midnight(end) > day;
    if (startsBefore && endsAfter) return 'Hele dagen';
    return `${startsBefore ? '' : hhmm(start)} - ${endsAfter ? '' : hhmm(end)}`;
  }
}

function isBlocked(element: InfoScreenData): boolean {
  return element.bookingType == 'BLOCKED';
}

function locationText(element: InfoScreenData): string {
  return element.resourceParent ? `${element.resourceParent} / ${element.resource}` : (element.resource ?? '');
}

function midnight(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

function hhmm(date: Date): string {
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}
